import { useRecoilState } from "recoil";
import "./LevelInformation.scoped.scss";
import { ageGuidePopUpState } from "../../../../recoil/commonUiAtom";

function LevelInformation() {
  const [agePop, setAgePop] = useRecoilState(ageGuidePopUpState);
  return agePop ? (
    <div className="layer-popup-grade">
      <div className="shadow" />
      <div className="popup-layer" onClick={() => setAgePop(false)}>
        <img
          src="https://file.valofe.com/Valofe_file/web/grade/btn_close.png"
          alt="게임이용등급 팝업 닫기"
          className="btn-pop-close"
        />
        <div className="grade-wrap">
          <div className="grade clearfix">
            <h3>
              루니아z는
              <br /> <span>12세 이용가</span> 게임물입니다.
            </h3>
            <div className="grade-character">
              <ul className="status">
                <li className="status violence">
                  <img
                    src="https://file.valofe.com/Valofe_file/web/grade/grade_violence.png"
                    alt="폭력성"
                  />
                </li>
                <li className="status fear">
                  <img
                    src="https://file.valofe.com/Valofe_file/web/grade/grade_fear.png"
                    alt="공포"
                  />
                </li>
                <li className="status crime">
                  <img
                    src="https://file.valofe.com/Valofe_file/web/grade/grade_crime.png"
                    alt="범죄"
                  />
                </li>
                <li className="status drug">
                  <img
                    src="https://file.valofe.com/Valofe_file/web/grade/grade_drug.png"
                    alt="약물"
                  />
                </li>
                <li className="status gambling">
                  <img
                    src="https://file.valofe.com/Valofe_file/web/grade/grade_gambling.png"
                    alt="사행성"
                  />
                </li>
                <li className="status sensibility">
                  <img
                    src="https://file.valofe.com/Valofe_file/web/grade/grade_sensibility.png"
                    alt="선정성"
                  />
                </li>
                <li className="status words">
                  <img
                    src="https://file.valofe.com/Valofe_file/web/grade/grade_words.png"
                    alt="언어의부적절성"
                  />
                </li>
              </ul>
            </div>
            <div className="grade-age">
              <ul className="status g-12">
                <li>
                  <ul>
                    <li className="status g-all">
                      <img
                        src="https://file.valofe.com/Valofe_file/web/grade/grade_all.png"
                        alt="전체이용가"
                      />
                    </li>
                    <li className="status g-12">
                      <img
                        src="https://file.valofe.com/Valofe_file/web/grade/grade_12.png"
                        alt="12세이용가"
                      />
                    </li>
                    <li className="status g-15">
                      <img
                        src="https://file.valofe.com/Valofe_file/web/grade/grade_15.png"
                        alt="15세이용가"
                      />
                    </li>
                    <li className="status g-18">
                      <img
                        src="https://file.valofe.com/Valofe_file/web/grade/grade_18.png"
                        alt="청소년이용불가"
                      />
                    </li>
                    <li className="status g-test">
                      <img
                        src="https://file.valofe.com/Valofe_file/web/grade/grade_test.png"
                        alt="평가용"
                      />
                    </li>
                  </ul>
                </li>
                <li>
                  <table className="tbl-grade">
                    <tbody>
                      <tr>
                        <td>제명</td>
                        <td>루니아Z</td>
                        <td>상호</td>
                        <td>(주)올엠</td>
                      </tr>
                      <tr>
                        <td>이용등급</td>
                        <td>12세이용가</td>
                        <td>등급분류번호</td>
                        <td>CC-NP-100120-002</td>
                      </tr>
                      <tr>
                        <td>등급분류 일자</td>
                        {/* <td>2007.11.09</td> */}
                        <td>2010-01-20</td>
                        <td>제작배급업신고번호</td>
                        {/* <td>M-03-01-2004-3001-24</td> */}
                        <td>제2006-000013호</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

export default LevelInformation;
